import { AST } from '@handlebars/parser';
import { IterableMustachePaths } from 'modules/handlebars/domain/statement/types';
import { isNull } from 'utils/tsHelpers';

export const isSnippetPath = (path: AST.PathExpression | null) =>
  !isNull(path) && path.parts.length === 1 && path.parts[0] === IterableMustachePaths.Snippet;
